import classNames from 'classnames';
import './ContentBoxHeading.scss';
import { Timestamp } from 'app/agriculture/components/Timestamp/Timestamp';

interface ContentBoxHeadingProps {
    className?: string;
    text: string;
    timestamp?: Date;
}

export function ContentBoxHeading({ className, text, timestamp }: ContentBoxHeadingProps) {
    return (
        <div className="ContentBox__heading">
            <h5 className={classNames(className, 'ContentBox__heading__text')}>{text}</h5>
            <Timestamp timestamp={timestamp} />
        </div>
    );
}
